export default __webpack_public_path__ + "static/media/playstore.b1f04f8d.png";